<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button class="btn btn-primary btn-back top-back-button" (click)="back()"><i
                                class="fa fa-chevron-left text-left" ></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Edit Payment Method</div>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
                <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage" > &nbsp;<span [innerHTML]="errorMessage"></span></div>
                <form autocomplete="off" class="w100 text-left mt-4 mb-b" [formGroup]="editPaymentForm">
               
                    <div class="row no-margin">
                        <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">Last Four Digits</label>
                            <div class="lableValue">{{userStoreService?.paymentDevice.accountLast4}}</div>
                        </div>
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">type</label>
                            <div class="lableValue">{{userStoreService?.paymentDevice.type}}</div>
                        </div>
                        <div class="col-12 col-sm-12 mb-4">
                            <label  class="lblPin">Short Name for reference optional (Max 20 CHARACTERS)</label><input class="form-control" (blur)="globalService.trimValue(f.shortName)"  formControlName="shortName" [ngClass]="{ 'is-invalid': submitted && f.shortName.errors }">
                            <div *ngIf="submitted && f.shortName.errors && f.shortName.errors"  class="invalid-feedback">Short Name should be max 20 characters.</div>
                        </div>
                        
                      
                       
                    </div>

                   
                </form>
            </div>

            <div class="container m-auto text-center"><a><button class="btn btn-primary btn-back" (click)="cancel()"> Cancel</button></a><a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="save()">Save </button></a></div>
        </div>
    </div>
</div>